type ValidationResult<T> =
  | { isValid: true; error: null }
  | { isValid: false; error: T };

export enum LotGoalNameError {
  Required,
  Duplicated,
}

export function validateLotGoalName<T extends { id: number; name: string }>(
  name: string,
  goals: T[],
  selectedGoalId: number | null
): ValidationResult<LotGoalNameError> {
  if (!name.trim()) {
    return { isValid: false, error: LotGoalNameError.Required };
  }

  const isDuplicate = goals.some(
    (item) =>
      item.name.trim().toLowerCase() === name.trim().toLowerCase() &&
      item.id !== selectedGoalId
  );

  if (isDuplicate) {
    return { isValid: false, error: LotGoalNameError.Duplicated };
  }

  return { isValid: true, error: null };
}
